<template>
  <div class="bg-primary-tint-6 py-8 md:py-12 lg:py-16 px-6 sm:px-8">
    <div class="max-w-7xl mx-auto flex items-start justify-center">
      <div class="flex flex-col items-start sm:flex-row">
        <LightBulb class="flex-shrink-0 mb-8 sm:mb-0 sm:mr-10 h-20 w-20" />
        <div class="max-w-4xl">
          <TypeOverline tag="p" class="text-primary mb-4 text-[18px]">
            {{ title }}
          </TypeOverline>
          <TypeDisplay
            tag="p"
            variant="mega"
            weight="regular"
            class="text-[#262338] leading-normal font-poppins"
          >
            {{ description }}
          </TypeDisplay>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import LightBulb from '~/assets/images/NewLightBulb.svg';
import { TypeBody, TypeDisplay, TypeOverline } from '@bambeehr/pollen';

export default defineComponent({
  name: 'Factoid',
  components: {
    TypeBody,
    TypeDisplay,
    TypeOverline,
    LightBulb,
  },
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
});
</script>
